import React from 'react'
import { useContentfulQuery } from '#src/containers/Contentful'
import PageMetadata from '../PageMetadata'

interface OpenGraphProps {
  slug?: string | null
}

interface DepartmentOpenGraphContentfulData {
  description?: string
  image?: {
    imageUrl: string
  }
}

const DepartmentOpenGraph: React.FC<OpenGraphProps> = ({ slug }) => {
  const { content } = useContentfulQuery<DepartmentOpenGraphContentfulData>({
    template: 'openGraphTemplate',
    variation: slug || 'default'
  })

  if (content) {
    const { description, image } = content

    return <PageMetadata description={description} imageUrl={image?.imageUrl} />
  }

  return null
}

export default DepartmentOpenGraph
